export default "__VITE_ASSET__7HIkD5wv__"